
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Authority } from '../models/Authority'

@Component
export default class Menu extends Vue {
	@Prop({ default: '' }) private view!: string

    private authority: Authority = new Authority()

	private clipped = true
	private drawer = false
	private miniVariant = false
	private right = true
	private title = '勤怠管理システム'
	private items = [
		{ title: 'メニュー', icon: 'mdi-home', link: '/Menu' },
		{ title: '勤務表', icon: 'mdi-calendar', link: '/WorkingList' },
		{ title: '申請書一覧', icon: 'mdi-file-document-edit-outline', link: '/ApplicationList' },
        { title: 'パスワード変更', icon: 'mdi-key-variant', link: '/EmployeePasswordEdit' }
	]

	private logout() {
		this.$store.dispatch('clear')
		this.$router.push({ name: 'Login' })
	}

    // #region 初期表示
    private async created() {
        //メニュー設定
        this.setAppMenu()
    }
	//#endregion

    //#region メニュー設定
    private async setAppMenu() {
        try {
            const data = { Authority: this.authority }

            const response = await this.$axios.post('api/AppBar/Get', data)

            ////権限
			this.authority = response.data.authority

			if (this.authority.roleSales) {
				//営業権限
                this.items = [
                    { title: 'メニュー', icon: 'mdi-home', link: '/Menu' },
                    { title: '勤務表', icon: 'mdi-calendar', link: '/WorkingList' },
                    { title: '月別集計表', icon: 'mdi-file-table-box-outline', link: '/MonthlyTabulation' },
					{ title: '申請書一覧', icon: 'mdi-file-document-edit-outline', link: '/ApplicationList' },
                    { title: 'パスワード変更', icon: 'mdi-key-variant', link: '/EmployeePasswordEdit' }
                ]
			}
			if (this.authority.roleLeader) {
				//リーダー権限
                this.items = [
                    { title: 'メニュー', icon: 'mdi-home', link: '/Menu' },
                    { title: '勤務表', icon: 'mdi-calendar', link: '/WorkingList' },
                    { title: '月別集計表', icon: 'mdi-file-table-box-outline', link: '/MonthlyTabulation' },
					{ title: '申請書一覧', icon: 'mdi-file-document-edit-outline', link: '/ApplicationList' },
                    { title: 'パスワード変更', icon: 'mdi-key-variant', link: '/EmployeePasswordEdit' }
                ]
			}

			if (this.authority.roleManager) {
				//管理職権限
                this.items = [
                    { title: 'メニュー', icon: 'mdi-home', link: '/Menu' },
                    { title: '勤務表', icon: 'mdi-calendar', link: '/WorkingList' },
                    { title: '月別集計表', icon: 'mdi-file-table-box-outline', link: '/MonthlyTabulation' },
					{ title: '申請書一覧', icon: 'mdi-file-document-edit-outline', link: '/ApplicationList' },
                    { title: 'パスワード変更', icon: 'mdi-key-variant', link: '/EmployeePasswordEdit' },
					//{ title: 'サンプル', icon: 'mdi-rocket', link: '/Sample' }
                ]
			}

			if (this.authority.roleBusinessAdmin) {
				//業務管理部権限
                this.items = [
                    { title: 'メニュー', icon: 'mdi-home', link: '/Menu' },
                    { title: '勤務表', icon: 'mdi-calendar', link: '/WorkingList' },
                    { title: '月別集計表', icon: 'mdi-file-table-box-outline', link: '/MonthlyTabulation' },
					{ title: '申請書一覧', icon: 'mdi-file-document-edit-outline', link: '/ApplicationList' },
                    { title: '従業員一覧', icon: 'mdi-account', link: '/EmployeeMaster' },
                    { title: 'パスワード変更', icon: 'mdi-key-variant', link: '/EmployeePasswordEdit' }
                ]
			}

			if (this.authority.roleWorkingHoursAdmin) {
				//総務管理者権限
                this.items = [
                    { title: 'メニュー', icon: 'mdi-home', link: '/Menu' },
                    { title: '勤務表', icon: 'mdi-calendar', link: '/WorkingList' },
                    { title: '月別集計表', icon: 'mdi-file-table-box-outline', link: '/MonthlyTabulation' },
					{ title: '申請書一覧', icon: 'mdi-file-document-edit-outline', link: '/ApplicationList' },
                    { title: '従業員一覧', icon: 'mdi-account', link: '/EmployeeMaster' },
					{ title: 'パスワード変更', icon: 'mdi-key-variant', link: '/EmployeePasswordEdit' },
					//{ title: 'サンプル', icon: 'mdi-rocket', link: '/Sample' }
                ]

			}

        } catch (e) {
            console.log(e.message)
        }
    }
	//#endregion
}
